import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from 'src/app/app.constants';
import { Observable } from 'rxjs';
import { FilterViewModel } from '../../shared/models/filter/filterViewModel';
import { StateService } from '../../planning/services/state.service';
import { map } from 'rxjs/operators';
import { IApiService } from '../../shared/interfaces/iHttpService';
import { ValidatedViewModel } from '../../shared/viewModels/validatedViewModel';
import { ModifiableEntityViewModel } from '../../incidents/viewModels/modifiableEntityViewModel';
import { ObjectTypes } from '../../shared/enums/objectTypes';
import { LightFilterUpdateModel } from '../../shared/models/filter/LightFilterUpdateModel';
import { TemplateRiskViewModel } from '../models/templateRiskViewModel';
import { TemplateRiskSimpleViewModel } from '../models/templateRiskSimpleViewModel';
import { JobCategoryViewModel } from '../../settings/viewModels/jobs/jobCategoryViewModel';
import { IncidentCategoryViewModel } from '../../settings/viewModels/incidentCategoryViewModel';

@Injectable({
  providedIn: 'root',
})
export class TemplateRisksService extends StateService<TemplateRiskViewModel> implements IApiService {
  private actionUrl: string;

  constructor(private http: HttpClient, private configuration: Configuration) {
    super();
    this.actionUrl = this.configuration.buildEndpoint(`TemplateRisk/`);
  }

  updateLight(item: LightFilterUpdateModel) {
    throw new Error('Method not implemented.');
  }

  list(filters: FilterViewModel[]): Observable<ModifiableEntityViewModel[]> {
    return this.http.post<TemplateRiskViewModel[]>(`${this.actionUrl}List`, filters);
  }

  listForAssessmentModal(): Observable<TemplateRiskSimpleViewModel[]> {
    return this.http.get<TemplateRiskSimpleViewModel[]>(`${this.actionUrl}ListForAssessments`).pipe(map(x => {
      return x.map(risk => {
        risk.impactTypeTitlesAsString = risk.impactTypeTitles.join(' | ');
        return risk;
      });
    }));
  }

  pinnedList(
    objectType: ObjectTypes,
    filters: FilterViewModel[],
    showPinnedOnly?: boolean
  ): Observable<ModifiableEntityViewModel[]> {
    throw new Error('Method not implemented.');
  }

  add(risk: TemplateRiskViewModel) {
    return this.http.post<ValidatedViewModel>(`${this.actionUrl}Add`, risk);
  }

  // addFromMasterIds(assesmentId: number, masterRiskIds: number[]) {
  //   return this.http.post<TemplateRiskViewModel[]>(`${this.actionUrl}AddFromMasterIds/${assesmentId}`, masterRiskIds);
  // }

  // getListForAssesment(assesmentId: number) {
  //   return this.http.get<TemplateRiskViewModel[]>(`${this.actionUrl}GetListForAssesment/${assesmentId}`);
  // }

  getList(
    employeeId: number,
    filters: FilterViewModel[],
    showPinnedOnly: boolean = false,
    customSortFilter: number = 0
  ): Observable<TemplateRiskViewModel[]> {
    return this.http.post<TemplateRiskViewModel[]>(
      `${this.actionUrl}List/${employeeId}/${showPinnedOnly}/${customSortFilter}`,
      filters
    );
  }

  details(riskId: number): Observable<TemplateRiskViewModel> {
    return this.http.get<TemplateRiskViewModel>(`${this.actionUrl}Details/${riskId}`);
  }

  update(risk: TemplateRiskViewModel) {
    return this.http.put<TemplateRiskViewModel>(`${this.actionUrl}Update`, risk);
  }

  updateLozenges(risk: TemplateRiskViewModel) {
    return this.http.post(`${this.actionUrl}UpdateLozenges`, risk);
  }

  delete(riskId: number) {
    return this.http.delete(`${this.actionUrl}Delete/${riskId}`);
  }

  archive(riskId: number, archive: boolean) {
    return this.http.post(`${this.actionUrl}Archive/${riskId}/${archive}`, null).pipe(
      map((x) => {
        this.deleteFromList(riskId);
        return x;
      })
    );
  }

  bulkArchive(riskIds: number[]) {
    return this.http.post(`${this.actionUrl}BulkArchive`, riskIds);
  }

  updateJobCategoriesForTemplateRisk(templateRiskId: number, jobCategoryIds: number[]): Observable<JobCategoryViewModel[]> {
    return this.http.post<JobCategoryViewModel[]>(`${this.actionUrl}UpdateJobCategories/${templateRiskId}`, jobCategoryIds);
  }

  updateIncidentCategoriesForTemplateRisk(templateRiskId: number, incidentCategoryIds: number[]): Observable<IncidentCategoryViewModel[]> {
    return this.http.post<IncidentCategoryViewModel[]>(`${this.actionUrl}UpdateIncidentCategories/${templateRiskId}`, incidentCategoryIds);
  }
}
